import { Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";

export default function Step2(props) {
    const chequesCount = useMemo(()=> props.dons?.reduce((tt,don)=>tt+don.repartition.cheques.length,0),[props.dons])
    const cbCount = useMemo(()=> props.dons?.reduce((tt,don)=>tt+(don.repartition.cb?.montant>0?1:0),0),[props.dons])
    const virmentsCount = useMemo(()=> props.dons?.reduce((tt,don)=>tt+(don.repartition.virement?.montant>0?1:0),0),[props.dons])

    return(
        <Stack direction='column' spacing={3}>
            <Stack direction='column' spacing={2}>
                <Typography variant="h6" align="center">Récapitulatif des recettes</Typography>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Typography>Recette locale: {props.local_part.toFixed(2)}€</Typography>
                    <Typography>Recette fédérale: {props.fed_part.toFixed(2)}€</Typography>
                    <Typography>Recette totale: {(props.local_part+props.fed_part).toFixed(2)}€</Typography>
                </Box>
            </Stack>
            <Stack direction='column' spacing={2}>
                <Typography variant="h6" align="center">Répartition des paiements</Typography>
                <Stack direction='row' spacing={5} flexWrap='wrap' alignItems='center'>
                    {[...new Set(props.dons.map(don=>don.repartition.especes.map(es=>es.montant)).flat())].map((money, index)=>{
                        const count = props.dons.reduce((tt,don)=>tt+(don.repartition.especes.find(es=>es.montant===money)?.count??0),0)
                        return <Typography key={index}>{count} {money>2?`billet`:'pièce'}{count>1?'s':''} de {money.toFixed(2)}€</Typography>
                    })}
                    <Typography>Total espèce: {props.dons.reduce((tt,don)=>tt+don.repartition.especes.reduce((te,es)=>te+es.montant*es.count,0),0).toFixed(2)}€</Typography>
                </Stack>
            </Stack>
            {chequesCount>0&&<Typography>{chequesCount} chèque{chequesCount>1?'s':''} pour un total de {props.dons.reduce((tt,don)=>tt+don.repartition.cheques.reduce((tc,ch)=>tc+ch.montant,0),0).toFixed(2)}€</Typography>}
            {cbCount>0&&<Typography>{cbCount} paiement{cbCount>1?'s':''} CB pour un total de {props.dons.reduce((tt,don)=>tt+(don.repartition.cb?.montant??0),0).toFixed(2)}€</Typography>}
            {virmentsCount>0&&<Typography>{virmentsCount} virement{virmentsCount>1?'s':''} pour un total de {props.dons.reduce((tt,don)=>tt+(don.repartition.virement?.montant??0),0).toFixed(2)}€</Typography>}
        </Stack>
    )
}